import { CartLine, Customer, ProductSearchResult, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
//import { IDimensionForSelectedVariant } from '@msdyn365-commerce-modules/retail-actions';

export const getExtensionPropertyValue: (
    product: ProductSearchResult | SimpleProduct | Customer | undefined | CartLine,
    propertyName: string
) => string | number | boolean | undefined = (product, propertyName) => {
    if (!product?.ExtensionProperties) {
        return undefined;
    }
    const extension = product.ExtensionProperties.find(ext => ext.Key === propertyName);
    if (!extension) {
        return undefined;
    }
    return extension.Value?.StringValue ?? extension.Value?.IntegerValue ?? extension.Value?.DecimalValue ?? extension.Value?.BooleanValue;
};

export function getMinValue<T extends { DimensionTypeValue: number; DimensionValue?: { Value?: string } }>(
    dimensions: T[],
    dimensionType: number
): number | undefined {
    const filtered = dimensions.filter(d => d.DimensionTypeValue === dimensionType);
    if (filtered.length === 0) {
        return undefined;
    }
    const min = filtered
        .map(d => parseFloat(d.DimensionValue?.Value ?? '0'))
        .reduce((min, curr) => (curr < min ? curr : min), Number.MAX_VALUE);
    return min !== Number.MAX_VALUE ? min : undefined;
}

export function getMaxValue<T extends { DimensionTypeValue: number; DimensionValue?: { Value?: string } }>(
    dimensions: T[],
    dimensionType: number
): number | undefined {
    const filtered = dimensions.filter(d => d.DimensionTypeValue === dimensionType);
    if (filtered.length === 0) {
        return undefined;
    }
    const max = filtered
        .map(d => parseFloat(d.DimensionValue?.Value ?? '0'))
        .reduce((max, curr) => (curr > max ? curr : max), Number.MIN_VALUE);
    return max !== Number.MIN_VALUE ? max : undefined;
}
